import colors from 'vuetify/es5/util/colors'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vuetify from 'vuetify'
import themes from '../themes'

require('vuetify/dist/vuetify.min.css')

const options = {
  theme: {
    dark: themes[process.env.VUE_APP_THEME].app.dark,
    themes: themes[process.env.VUE_APP_THEME].app.themes
  },
  options: {
    customProperties: true
  },
  icons: {
    iconfont: 'md' // 'md' || 'mdi' || 'fa' || 'fa4'
  }
}

export default new Vuetify(options)
